module.exports = __webpack_public_path__ + "img/zhihi3.27a5d549.png";